import { CellAction, EllipsisText } from "@maxhub/max-ui"
import { PlaceholderIcon } from "../shared/PlaceholderIcon"

export const CellActionEllipsizedExample = {
    title: 'CellAction - Ellipsized',
    defaultPlatform: 'ios',
    defaultZoom: 100,

    controls: [],

    Preview(){
        return (
            <CellAction
                before={<PlaceholderIcon />}
                mode="primary"
                showChevron
            >
                <EllipsisText>Very long action text that will be ellipsized</EllipsisText>
            </CellAction>
        )
    },

    getCode(){
        return `<CellAction
  before={<Icon28Placeholder />}
  mode="primary"
  showChevron
>
  <EllipsisText>Very long action text that will be ellipsized</EllipsisText>
</CellAction>`
    }
}